import e from "./modules/index.js";
export { default } from "./modules/index.js";
export { default as Header } from "./modules/components/header/index.js";
export { default as Slider } from "./modules/components/slider/index.js";
export { default as Menu } from "./modules/components/slider/menu.js";
export { default as FastNav } from "./modules/components/fastnav/index.js";
export { default as ScrollBar } from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./modules/components/scrollbar/index.scss.js";